import { postAsync } from 'utils/fetch';
import { ReportFilters, ReportRow } from './reports.types';
import {
    PowerTableGetter,
    PowerTableGetterProps
} from 'ui/PowerTable/PowerTable.types';
import { PaginationResponse } from 'typings/pagination';
import { formatFileDateTime } from 'utils/date';

export const getReport: PowerTableGetter<
    ReportRow,
    PaginationResponse<ReportRow>,
    ReportFilters
> = ({ filters, pagination, search }) =>
    postAsync<PaginationResponse<ReportRow>>(`Report/Assigns`, {
        ...filters,
        search,
        pagination
    });

export const createReportFile = ({
    filters,
    search
}: PowerTableGetterProps<ReportFilters>) =>
    postAsync<File>(
        `Report/AssignsFile`,
        {
            ...filters,
            search
        },
        {
            download: true,
            downloadFileName: `Отчет ${formatFileDateTime()}.xlsx`
        }
    );

export const downloadAssignsReport = (ids: number[]) =>
    postAsync(`Document/GetDocumentsByAssigns`, ids, {
        download: true
    });
